import { Chip as JoyChip, Stack, styled } from '@mui/joy';

import { BomPartNumber } from 'bom/elements';
import { SelectAttributePartButton } from 'quotes/components';
import { AttributePartType } from 'quotes/components/AttributePartDetails';
import { IAttributePartPayload, IQuotePart } from 'quotes/types';
import { Color } from 'theme/enums';

interface IProps {
  quotePart: IQuotePart;
  onPartNumberClick?: (quotePart: IQuotePart) => void;
  isSelectPartAllowed: boolean;
  onAttachParts?: (parts: IAttributePartPayload[]) => Promise<{ newRows: IQuotePart[] }>;
}

const Chip = styled(JoyChip)({
  borderRadius: 3,
});

export const BaseCodePart = ({
  quotePart,
  onPartNumberClick,
  isSelectPartAllowed,
  onAttachParts,
}: IProps) => {
  return (
    <Stack>
      <Chip color={Color.WARNING}>
        <BomPartNumber
          bomPart={quotePart}
          onPartClick={
            onPartNumberClick ? (bomPart) => onPartNumberClick(bomPart as IQuotePart) : undefined
          }
        />
      </Chip>

      {isSelectPartAllowed && (
        <SelectAttributePartButton
          type={AttributePartType.BASE_CODE}
          selectedPart={quotePart}
          onAttachParts={onAttachParts}
        />
      )}
    </Stack>
  );
};
